import React, { useState } from 'react';
import { importHistory } from '../services/storage';

const DragDropImport = ({ onImport, onError }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files.length === 0) return;

    const file = files[0];
    if (!file.name.endsWith('.json')) {
      if (onError) {
        onError('Пожалуйста, выберите JSON файл');
      }
      return;
    }

    try {
      const updatedHistory = await importHistory(file);
      if (onImport) {
        onImport(updatedHistory);
      }
    } catch (error) {
      if (onError) {
        onError(error.message);
      }
    }
  };

  if (!isDragging) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center animate-fade-in"
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div className="bg-white rounded-2xl p-12 max-w-lg w-full mx-4 shadow-2xl animate-scale-in">
        <div className="text-center">
          <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
            <svg className="w-12 h-12 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Отпустите файл для импорта
          </h3>
          <p className="text-gray-600">
            Загрузите JSON файл с историей восстановлений
          </p>
        </div>
      </div>
    </div>
  );
};

export default DragDropImport;











